import { z } from "zod";
import { zEmail, zId } from "./common.js";

/**
 * The app marketplace. Third-party developers APPLY to list an app; a
 * platform operator (a separate login from org accounts) reviews the
 * applications; approved apps appear in every org's marketplace to install.
 * The extension runtime (actions, config, webhooks) comes later — today an
 * install is the org's registration of interest and the listing foundation.
 */

export const APP_CATEGORIES = ["Direct mail", "Payments", "Communications", "Analytics", "Data & enrichment", "Other"] as const;
export const zAppCategory = z.enum(APP_CATEGORIES);

export const APP_APPLICATION_STATUSES = ["pending", "approved", "rejected"] as const;
export const zAppApplicationStatus = z.enum(APP_APPLICATION_STATUSES);
export type AppApplicationStatus = z.infer<typeof zAppApplicationStatus>;

/** the public developer application form */
export const zApplyToMarketplace = z.object({
  name: z.string().trim().min(2).max(100),
  tagline: z.string().trim().min(5).max(140),
  description: z.string().trim().min(20).max(3000),
  category: zAppCategory,
  website: z.string().trim().url().max(300),
  developerName: z.string().trim().min(2).max(200),
  developerEmail: zEmail,
});
export type ApplyToMarketplace = z.infer<typeof zApplyToMarketplace>;

/** operator review decision */
export const zReviewApplication = z.object({
  status: z.enum(["approved", "rejected"]),
  reviewNotes: z.string().trim().max(2000).optional(),
});
export type ReviewApplication = z.infer<typeof zReviewApplication>;

export const zOperatorLogin = z.object({
  email: zEmail,
  password: z.string().min(8).max(200),
});
export type OperatorLogin = z.infer<typeof zOperatorLogin>;

export const zInstallApp = z.object({
  appId: zId,
});
